'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getTransformMatrix = getTransformMatrix;
function getTransformMatrix(element) {
  var matrix = window.getComputedStyle(element).transform;
  var matrixArray = [0, 0, 0, 0, 0, 0];

  if (matrix && matrix !== 'none') {
    matrixArray = matrix.replace('matrix(', '').replace(')', '').replace(',', '').split(' ').map(function (value) {
      return parseFloat(value);
    });
  }

  return matrixArray;
}